(function() {
  let lastScrollTop = 0;
  const body = document.body;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Remove classes when at the top
    if (scrollTop === 0) {
      body.classList.remove('scroll-down', 'scroll-top');
      lastScrollTop = 0;
      return;
    }
    
    // Determine scroll direction
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      body.classList.remove('scroll-top');
      body.classList.add('scroll-down');
    } else if (scrollTop < lastScrollTop) {
      // Scrolling up
      body.classList.remove('scroll-down');
      body.classList.add('scroll-top');
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Throttle scroll events for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  // Initialize on page load
  handleScroll();
})();

